import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import CoachProgramsFilterBar from './CoachProgramsFilterBar'
import CoachProgramsList from './CoachProgramsList'
import { selectFilteredCategory, selectFiltersNumber } from '../../../reducers/groupProgramsReducer'
import NoPrograms from './EmptyProgramsList'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const CoachProgramsActiveTab = ({ fetchPrograms }) => {
  const active = useSelector(state => state.groupPrograms.active)
  const filtersNumber = useSelector(state => selectFiltersNumber(state, active.filters))
  const filteredCategory = useSelector(state => selectFilteredCategory(state, active.filters?.categoryId))
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  return (
    <>
      <CoachProgramsFilterBar
        filters={active.filters}
        filteredCategory={filteredCategory}
        filtersNumber={filtersNumber}
        search={active.search}
        tab={'active'}
      />

      {
        active.programs.length > 0 ?
          <CoachProgramsList
            programs={active.programs}
            timezone={timezone}
            hasMore={active.hasMore}
            fetchPrograms={() => fetchPrograms(active, 'active')}
          />
          :
          active.hasMore === false ?
            (filtersNumber > 0 || active.search) ? (
              <NoPrograms
                title='No Programs Found'
                subtitle='There are no programs that match the search you made, clear all filters and try again.'/>
            ) : (
              <NoPrograms
                title='No Active Programs Available'
                subtitle='Create a Program and make it live'/>
            ) : (
              <Loader message='loading programs' />
            )
      }
    </>
  )
}

CoachProgramsActiveTab.propTypes = {
  fetchPrograms: PropTypes.func,
}

export default CoachProgramsActiveTab
